import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Register } from '../../_models/register';
import { Caller } from '../../_models/caller';
import { Globals } from '../../_models/globals';
import { ApiIntegration } from '../../_services/api.integration';
import { User } from '../../_models/user';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-registration1',
  templateUrl: './registration1.component.html',
  styleUrls: ['./registration1.component.css']
})

export class Registration1Component implements OnInit {
  mobileNumber: string = "";
  emailValidationMessage: string = "";
  phoneValidationMessage: string = "";
  passwordValidationMessage: string = "";
  successMessage: string = "";
  errorMessage: string = "";
  servicesError: string = "";
  nameError: string = "";
  companyError: string = "";
  emailError: string = "";
  phoneError: string = "";
  explain: string = "";
  accountId: any;
  registerForm: UntypedFormGroup;
  services = [];
  registrationSuccess: boolean = false;
  requestSuccess: boolean = false;
  disableSubmitBtn: boolean = false;
  type: any;

  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute, public register: Register, public caller: Caller, public g: Globals, private fb: UntypedFormBuilder, private user: User, private api: ApiIntegration) {
    this.g.accessLeftMenu = "login";
    this.type = this.route.snapshot.params['type'];
    if (this.type === 'reg') {
      this.type = "ACCOUNT_OWNER";
    } else {
      this.type = "DEMO_ACCOUNT";
    }
  }

  ngOnInit() {
    this.clear();
  }

  validateCompany() {
    this.companyError = "";
    if (this.register.companyName == '' || this.register.companyName === null || this.register.companyName === undefined || this.register.companyName === 'undefined') {
      this.companyError = 'Please enter Company Name';
    }
  }

  createName() {
    this.nameError = "";
    if (this.register.name == '' || this.register.name === null || this.register.name === undefined || this.register.name === 'undefined') {
      this.nameError = 'Please enter Name';
      return false;
    }
  }

  next() {
    if (this.emailError == "" && this.phoneError == "") {
      this.emailError = "";
      this.phoneError = "";
      this.nameError = "";
      this.companyError = "";

      if (this.register.email == '' || this.register.email === null || this.register.email === undefined || this.register.email === 'undefined') {
        console.log(this.register.email);
        this.emailError = 'Please enter Email';
      }
      if (this.register.mobile == '' || this.register.mobile === null || this.register.mobile === undefined || this.register.mobile === 'undefined') {
        this.phoneError = 'Please enter Phone Number';
      }
      if (this.register.companyName == '' || this.register.companyName === null || this.register.companyName === undefined || this.register.companyName === 'undefined') {
        this.companyError = 'Please enter Company Name';
      }
      if (this.register.name == '' || this.register.name === null || this.register.name === undefined || this.register.name === 'undefined') {
        this.nameError = 'Please enter Name';
      }
      if (this.emailError != "" || this.phoneError != "" || this.nameError != "" || this.companyError != "") {
        return false;
      }
    }
  }

  registerSubmit() {
    this.g.loaderDisplay = "display";
    if (this.emailError == "Email Id Already Exists.") {
         this.errorMessage = this.emailError;
         this.g.loaderDisplay = "";
         return false;
    }
    if (this.phoneError == "Mobile Number Already Exists.") {
         this.errorMessage = this.phoneError;
         this.g.loaderDisplay = "";
         return false;
    }
    this.errorMessage = "";
    this.disableSubmitBtn = true;
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/registerCompany', {
      "approvalStatus": "NEW",
      "organizationId": 1,
      "companyName": this.register.companyName,
      "email": this.register.email,
      "mobileNumber": Number(this.register.mobile),
      "name": this.register.name,
      "website": this.register.website,
      "password": 123456,
      "reEnterPassword": 123456,
      "accountType": this.type
    },
      {
        headers: header1
      }).subscribe(data => {
        if (data['code'] == 200) {
          this.g.loaderDisplay = "";
          this.accountId = data['id'];
          this.warehouseFunction();
        }
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.disableSubmitBtn = false;
          this.g.loaderDisplay = "";
          this.errorMessage = "Registration Failed, please re-try.";
        }
      )
  }

  clear() {
    this.register.companyName = "";
    this.register.mobile = "";
    this.register.name = "";
    this.register.email = "";
  }

  validateEmail() {
    this.emailError = "";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniqueEmail?email=' + this.register.email + "&userType=" +"USER",
    {
      headers: header1
    }).subscribe(data => {
      if (data['code'] == 200) {

      } else {
        var errorMessage = "invalid email";
        if (data['code'] == 400) {
          errorMessage = data['message'];
        }
        this.emailError = errorMessage;
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.emailError = "Please enter Email.";
      }
    )
  }

  validateMobile() {
    this.phoneError = "";
    if (this.register.mobile == '' || this.register.mobile === null || this.register.mobile === undefined || this.register.mobile === 'undefined') {
      this.phoneError = 'Please enter Mobile Number';
      return false;
    }
    let i = this.register.mobile.indexOf('0');
    if (i == 0) {
      this.phoneError = "Number should not start with 0";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniqueMobileNumber', this.register.mobile,
      { headers: header1 }).subscribe(data => {
        if (data['code'] == 200) {
        } else {
          var errorMessage = "invalid mobile";
          if (data['code'] == 400) {
            errorMessage = data['message'];
          }
          this.phoneError = errorMessage;
        }
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.phoneError = "Please enter Mobile Number";
        }
      )
  }

  warehouseFunction() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/warehouse-requests', {
      "approvalStatus": "NEW",
      "organizationId": 1,
      "accountOwnerId": this.accountId
    },
      {
        headers: header1
      }).subscribe(data => {
        this.requestSuccess = true;
        this.caller.parent = "REGISTER";
        this.g.loaderDisplay = "";
        this.router.navigate(['/access/info']);
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.errorMessage = "Registration Failed, please re-try.";
        }
      )
  }
}
